import { useQuery } from '@tanstack/react-query';
import SubmissionsMetadataService from '../../services/submissions-metadata';

export const DEFAULT_CHANNELS_QUERY_KEY = ['submissions_metadata'];

export type ChannelDefaults = {
  email: boolean;
  assistant: boolean;
  push: boolean;
};

/**
 * Returns the program-level default notification channels configured via kai's
 * Campaign Settings, sourced from /submissions/metadata. The backend handles
 * the SetChannelDefaults.Enabled feature flag and falls back to all channels
 * on when no defaults have been set, so the caller can treat the response as
 * authoritative.
 */
export const useDefaultChannelsQuery = () => {
  return useQuery<ChannelDefaults | undefined, Error>({
    queryKey: DEFAULT_CHANNELS_QUERY_KEY,
    queryFn: async () => {
      const response = await new SubmissionsMetadataService().fetch();
      const channels =
        response.data?.data?.attributes?.composer
          ?.notification_channels_configuration;
      if (!channels) return undefined;
      return {
        email: !!channels.email?.default,
        assistant: !!channels.notification_center?.default,
        push: !!channels.push?.default,
      };
    },
    retry: false,
    meta: { persist: false },
  });
};
